import React from 'react';
import { styled } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { Colors } from 'library';
import { DropdownMenuItem } from 'library/ui';
import { useUserContext } from 'UserContext';
import { LayoutTopBar } from 'parent-portal/navigation/LayoutTopBar';

const MedicalProviderLayout = ({ children }: { children: React.ReactNode }) => {
    const { user, logout } = useUserContext();
    const initials = user ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase() : '';
    const accountMenuItems: DropdownMenuItem[] = [
        {
            label: 'Sign Out',
            icon: <Logout fontSize="small" />,
            onClick: () => logout('/login'),
            id: 'sign-out-button',
        },
    ];

    return (
        <Root>
            <LayoutTopBar
                small={false}
                onToggleSidebar={() => undefined}
                initials={initials}
                accountMenuItems={accountMenuItems}
            />
            <Main>{children}</Main>
        </Root>
    );
};

const Root = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: Colors.white,
});

const Main = styled('main')({
    flexGrow: 1,
    marginTop: 60,
    padding: 24,
    backgroundColor: Colors.surface,
    minHeight: 'calc(100vh - 60px)',
});

export default MedicalProviderLayout;
